import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import './styles/styles.scss';
import './styles/utility.scss';
import axiosService from './modules/global/services/axios';

import moment from 'moment';
import 'moment/locale/id';

const vuetify = createVuetify({
    components,
    directives,
});

const app = createApp(App);
app.config.globalProperties.$moment = moment;
app.use(axiosService);
app.use(vuetify);
app.use(router);

app.mount('#app');
